/**
 * Shared constants for export functionality
 */

/**
 * Time-to-live for presigned URLs (fileWebServerPath) in minutes.
 * Presigned URLs expire after 50 minutes.
 */
export const FILE_WEB_SERVER_PATH_TTL_MINUTES = 50;
